import { styled } from "linaria/react";
import { css } from "linaria";

export const HintsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
  padding: var(--space-225) var(--space-500) var(--space-225) var(--space-200);
  margin-bottom: var(--space-400);
  background: var(--secondary-yellow_light);

  @media (--only-mobile) {
    margin-bottom: var(--space-200);
  }
`;

export const HintContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: var(--space-50);
`;

export const sphere = css`
  flex-shrink: 0;
  width: var(--space-50);
  height: var(--space-50);
  margin-top: var(--space-100);
  background: var(--text-primary);
  border-radius: 50%;
`;
